import { Injectable } from '@angular/core';
import { InvoiceReceipt } from '../model';
import { BaseService } from '../../shared/baseService';
@Injectable({
    providedIn: 'root'
})

export class InvoiceReceiptsService extends BaseService<InvoiceReceipt> {
  
    constructor() {
        super('InvoiceReceipt');
    }
}
